import React, { useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound, Check } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Tela bloqueante de troca de senha obrigatória no primeiro acesso
const ChangePasswordGate = ({ onDone }) => {
  const [senha, setSenha] = useState("");
  const [conf, setConf] = useState("");
  const [loading, setLoading] = useState(false);

  const salvar = async (e) => {
    e.preventDefault();
    if (senha.length < 6) return toast.error("A senha deve ter ao menos 6 caracteres");
    if (senha !== conf) return toast.error("As senhas não conferem");
    try {
      setLoading(true);
      await axios.post(`${API}/auth/change-password`, { nova_senha: senha });
      toast.success("Senha alterada com sucesso!");
      onDone();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao alterar senha");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8" data-testid="change-password-gate">
        <div className="mx-auto w-14 h-14 bg-slate-900 rounded-full flex items-center justify-center mb-4">
          <KeyRound className="w-7 h-7 text-white" />
        </div>
        <h1 className="text-xl font-bold text-slate-900 text-center">Defina sua nova senha</h1>
        <p className="text-sm text-slate-500 text-center mt-1 mb-6">Por segurança, troque a senha inicial para continuar.</p>
        <form onSubmit={salvar} className="space-y-4">
          <div className="space-y-2">
            <Label className="text-slate-700">Nova senha</Label>
            <Input type="password" value={senha} onChange={(e) => setSenha(e.target.value)} className="h-11" data-testid="change-pwd-input" />
          </div>
          <div className="space-y-2">
            <Label className="text-slate-700">Confirmar nova senha</Label>
            <Input type="password" value={conf} onChange={(e) => setConf(e.target.value)} className="h-11" data-testid="change-pwd-confirm" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-slate-900 hover:bg-slate-800 text-white" data-testid="change-pwd-submit">
            <Check className="w-4 h-4 mr-2" /> {loading ? "Salvando..." : "Salvar e entrar"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordGate;
